import { createSelector } from 'reselect';
import { CUSTOM_DOMAIN_INSTITUTIONS } from './constants';
import { selectCurrentProtocol } from '../location/selectors';

export const makeSelectCustomOriginFromInstitutionPath = (institutionPrefix) =>
  createSelector(
    [selectCurrentProtocol],
    (currentProtocol) => {
      const customDomain = CUSTOM_DOMAIN_INSTITUTIONS.find(
        (item) => item.get('path') === institutionPrefix
      );
      return customDomain
        ? `${currentProtocol}//${customDomain.get('domain')}`
        : null;
    }
  );
